import { render, staticRenderFns } from "./UIRadioButton.vue?vue&type=template&id=708b3d37&scoped=true"
import script from "./UIRadioButton.vue?vue&type=script&lang=js"
export * from "./UIRadioButton.vue?vue&type=script&lang=js"
import style0 from "./UIRadioButton.vue?vue&type=style&index=0&id=708b3d37&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708b3d37",
  null
  
)

export default component.exports